import VerticalLine_VerticalSolidLineComponent from '@wix/thunderbolt-elements/src/components/VerticalLine/viewer/skinComps/BaseVerticalLine/VerticalSolidLine.skin';
import VerticalLine_VerticalSolidLineController from '@wix/thunderbolt-elements/src/components/VerticalLine/viewer/VerticalLine.controller';


const VerticalLine_VerticalSolidLine = {
  component: VerticalLine_VerticalSolidLineComponent,
  controller: VerticalLine_VerticalSolidLineController
};


export const components = {
  ['VerticalLine_VerticalSolidLine']: VerticalLine_VerticalSolidLine
};

